var _slicedToArray = require("/home/mikhail/Documents/kolmonet/app/node_modules/@babel/runtime/helpers/slicedToArray");

var _regeneratorRuntime = require("/home/mikhail/Documents/kolmonet/app/node_modules/@babel/runtime/regenerator");

var _asyncToGenerator = require("/home/mikhail/Documents/kolmonet/app/node_modules/@babel/runtime/helpers/asyncToGenerator");

var _classCallCheck = require("/home/mikhail/Documents/kolmonet/app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/home/mikhail/Documents/kolmonet/app/node_modules/@babel/runtime/helpers/createClass");

(function () {
  if (typeof global !== "undefined") {// global already exists
  } else if (typeof window !== "undefined") {
    window.global = window;
  } else if (typeof self !== "undefined") {
    self.global = self;
  } else {
    throw new Error("cannot export (neither global, window nor self is defined)");
  }

  global.WasmGo =
  /*#__PURE__*/
  function () {
    "use strict";

    function _class(raw_wasm, jsglue_go) {
      _classCallCheck(this, _class);

      this.raw_wasm = raw_wasm;
      this.jsglue_go = jsglue_go;
      this.mod = null;
      this.inst = null;
      this.Go = null;
      if (!this.raw_wasm) throw new Error("Not specified raw_wasm object!");
      if (!this.jsglue_go) throw new Error("Not specified jsglue_go object!");
    }

    _createClass(_class, [{
      key: "un_init",
      value: function () {
        var _un_init = _asyncToGenerator(
        /*#__PURE__*/
        _regeneratorRuntime.mark(function _callee() {
          var result;
          return _regeneratorRuntime.wrap(function _callee$(_context) {
            while (1) {
              switch (_context.prev = _context.next) {
                case 0:
                  result = {
                    status: "ok"
                  };

                  try {// TODO: if make call _gowasm_stop(); after 10 seconds will exception...
                    //_gowasm_stop();
                  } catch (error) {
                    result.status = "Exception while un_init: " + error;
                  }

                  return _context.abrupt("return", result);

                case 3:
                case "end":
                  return _context.stop();
              }
            }
          }, _callee);
        }));

        function un_init() {
          return _un_init.apply(this, arguments);
        }

        return un_init;
      }()
    }, {
      key: "init",
      value: function () {
        var _init = _asyncToGenerator(
        /*#__PURE__*/
        _regeneratorRuntime.mark(function _callee2() {
          var result, utf8decoder, jsglue_go;
          return _regeneratorRuntime.wrap(function _callee2$(_context2) {
            while (1) {
              switch (_context2.prev = _context2.next) {
                case 0:
                  result = {
                    status: "ok"
                  };
                  _context2.prev = 1;

                  if (this.inst) {
                    _context2.next = 13;
                    break;
                  }

                  utf8decoder = new TextDecoder();
                  jsglue_go = utf8decoder.decode(this.jsglue_go);
                  this.Go = Function('"use strict";' + jsglue_go + 'return new Go();')();
                  _context2.next = 8;
                  return new WebAssembly.compile(this.raw_wasm);

                case 8:
                  this.mod = _context2.sent;
                  _context2.next = 11;
                  return new WebAssembly.instantiate(this.mod, this.Go.importObject);

                case 11:
                  this.inst = _context2.sent;
                  this.Go.run(this.inst).then(function (resutl) {
                    console.log("end run");
                  });

                case 13:
                  _context2.next = 18;
                  break;

                case 15:
                  _context2.prev = 15;
                  _context2.t0 = _context2["catch"](1);
                  result.status = "Exception while init: " + _context2.t0;

                case 18:
                  return _context2.abrupt("return", result);

                case 19:
                case "end":
                  return _context2.stop();
              }
            }
          }, _callee2, this, [[1, 15]]);
        }));

        function init() {
          return _init.apply(this, arguments);
        }

        return init;
      }()
    }, {
      key: "exec",
      value: function () {
        var _exec = _asyncToGenerator(
        /*#__PURE__*/
        _regeneratorRuntime.mark(function _callee3(args) {
          var result, _iteratorNormalCompletion, _didIteratorError, _iteratorError, _iterator, _step, _step$value, ArgName, ArgValue, res;

          return _regeneratorRuntime.wrap(function _callee3$(_context3) {
            while (1) {
              switch (_context3.prev = _context3.next) {
                case 0:
                  result = {
                    status: "Not implemented",
                    data: []
                  };
                  _context3.prev = 1;
                  _iteratorNormalCompletion = true;
                  _didIteratorError = false;
                  _iteratorError = undefined;
                  _context3.prev = 5;
                  _iterator = args[Symbol.iterator]();

                case 7:
                  if (_iteratorNormalCompletion = (_step = _iterator.next()).done) {
                    _context3.next = 18;
                    break;
                  }

                  _step$value = _slicedToArray(_step.value, 2), ArgName = _step$value[0], ArgValue = _step$value[1];

                  if (!(null == ArgValue)) {
                    _context3.next = 12;
                    break;
                  }

                  result.status = "Wrong usage, one of arguments is empty";
                  return _context3.abrupt("return", result);

                case 12:
                  if (_gowasm_setArg(ArgName, ArgValue)) {
                    _context3.next = 15;
                    break;
                  }

                  result.status = _gowasm_lastError();
                  return _context3.abrupt("return", result);

                case 15:
                  _iteratorNormalCompletion = true;
                  _context3.next = 7;
                  break;

                case 18:
                  _context3.next = 24;
                  break;

                case 20:
                  _context3.prev = 20;
                  _context3.t0 = _context3["catch"](5);
                  _didIteratorError = true;
                  _iteratorError = _context3.t0;

                case 24:
                  _context3.prev = 24;
                  _context3.prev = 25;

                  if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                  }

                case 27:
                  _context3.prev = 27;

                  if (!_didIteratorError) {
                    _context3.next = 30;
                    break;
                  }

                  throw _iteratorError;

                case 30:
                  return _context3.finish(27);

                case 31:
                  return _context3.finish(24);

                case 32:
                  _context3.next = 37;
                  break;

                case 34:
                  _context3.prev = 34;
                  _context3.t1 = _context3["catch"](1);
                  result.status = "Exception while setArg: " + _context3.t1;

                case 37:
                  _context3.prev = 37;
                  res = _gowasm_execute();

                  if (!res) {
                    _context3.next = 44;
                    break;
                  }

                  result.status = "ok";
                  result.data = res;
                  _context3.next = 46;
                  break;

                case 44:
                  result.status = _gowasm_lastError();
                  return _context3.abrupt("return", result);

                case 46:
                  _context3.next = 51;
                  break;

                case 48:
                  _context3.prev = 48;
                  _context3.t2 = _context3["catch"](37);
                  result.status = "Exception while execute: " + _context3.t2;

                case 51:
                  return _context3.abrupt("return", result);

                case 52:
                case "end":
                  return _context3.stop();
              }
            }
          }, _callee3, null, [[1, 34], [5, 20, 24, 32], [25,, 27, 31], [37, 48]]);
        }));

        function exec(_x) {
          return _exec.apply(this, arguments);
        }

        return exec;
      }()
    }]);

    return _class;
  }();
})();